module.exports = __webpack_public_path__ + "img/txt.d8b68cb3.svg";